import { FC, memo } from 'react';

import { Box } from '@mui/material';

import { TooltipComponent } from 'components/_basic/TooltipComponent';

import { IRequiredTooltipProps as IProps } from './types';

import styles from './RequiredLabelTooltip.module.scss'

export const RequiredLabelTooltip: FC<IProps> = memo(({ text, requiredForAI, tooltipText }) => (
  <>
    {requiredForAI ? (
      <TooltipComponent title={tooltipText}>
        <Box className={styles.aiTextDecoration} component="span">{text}&nbsp;*</Box>
      </TooltipComponent>
    ) : (
      text
    )}
  </>
));
